import {  Component ,  EventEmitter ,  Input ,  OnChanges ,  OnInit ,  Output  } from '@angular/core';
import {NgbDate, NgbCalendar, NgbDateParserFormatter, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import { FALSE } from '../../../utils/config/const';

@Component({
  selector: 'app-date-range',
  templateUrl: './date-range.component.html',
  styleUrls: ['./date-range.component.css']
})
export class DateRangeComponent implements OnInit, OnChanges{

  @Input() start: string = null;
  @Input() end: string = null;
  @Input() isVisibleLabelDa:boolean = false;
  @Input() isVisibleLabelA:boolean = false;
  @Output() changeRange = new EventEmitter<any>();

  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate | null;
  toDate: NgbDate | null;
  maxDate: NgbDateStruct;


  
  iconButton:string = "fas fa-calendar";

  constructor(
    private calendar: NgbCalendar, 
    public formatter: NgbDateParserFormatter) {
      this.start = '';
      this.end = '';
      let now = this.calendar.getToday();
      this.maxDate = { year: now.year, month: now.month, day: now.day };
  }

  ngOnInit() {
    console.log(this.start);
    this.setFromDate(this.start);
    this.setToDate(this.end);
  }

  setFromDate(value){
    if(this.start != null && this.start != "" && typeof this.start != typeof undefined){
      this.fromDate = this.convertStringToNgbDate(value);
    }else{
      this.fromDate = null;
    } 
  }

  setToDate(value){
    if(this.end != null && this.end != "" && typeof this.end != typeof undefined){
      this.toDate = this.convertStringToNgbDate(value);
    }else{
      this.toDate = null;
    } 
  }


  ngOnChanges(changes){
    console.log(changes);
    if(changes != null){
      if(changes.hasOwnProperty('start')){
        if(changes.start.firstChange == FALSE && changes.start.previousValue != changes.start.currentValue){
          this.setFromDate(changes.start.currentValue);
        }
      }
      if(changes.hasOwnProperty('end')){
        if(changes.end.firstChange == FALSE && changes.end.previousValue != changes.end.currentValue){
          this.setToDate(changes.end.currentValue);
        }
      }
    }
  }


  convertStringToNgbDate(dateString){
    let d = Date.parse(dateString);
    let dt = new Date(d);
    let dateNgbDateStruct: NgbDateStruct ={
      year: dt.getUTCFullYear(),
      month: dt.getUTCMonth() + 1,
      day: dt.getUTCDate()
    } ;
    return new NgbDate(dateNgbDateStruct.year, dateNgbDateStruct.month, dateNgbDateStruct.day); 
  }


  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
    if(this.fromDate != null && typeof this.fromDate != typeof undefined && this.toDate != null && typeof this.toDate != typeof undefined){
      this.changeDateRange();
    }
  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) &&
        date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) { return this.toDate && date.after(this.fromDate) && date.before(this.toDate); }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) ||
        this.isHovered(date);
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }

  convertDateToString(value:NgbDate){
    let res = '';
    if(value!=null){
      res = value.year+"-";
      if (value.month < 10) {
        res = res + '0';
      }
      res = res+value.month + "-";
      if (value.day < 10) {
        res = res + '0';
      }
      res = res + value.day;
    }
    return res;
  }

  changeDateRange() {
    let dateFromDate = this.convertDateToString(this.fromDate);
    if(this.start != dateFromDate){this.start = dateFromDate;}
    let dateToDate = this.convertDateToString(this.toDate);
    if(this.end != dateToDate){this.end = dateToDate;}

    this.changeRange.emit({
      fromDate:this.fromDate,
      toDate:this.toDate
    });
  }

}
